import { ClipUpload, type ClipUploadFile } from "@components/ClipUpload/ClipUpload";
import { uploadVideo } from "@apis/uploadVideo";
import { Trans } from "react-i18next";
import { validateReferenceVideoBeforeUpload, VIDEO_FILE_ACCEPT } from "@pages/videoRemake/referenceVideoUpload";

export interface ReferenceVideoFilePanelProps {
  onUploadSuccess?: (file: ClipUploadFile) => void;
}

export const ReferenceVideoFilePanel = ({ onUploadSuccess }: ReferenceVideoFilePanelProps) => {
  return (
    <>
      <div className="flex items-start gap-[4px] pt-[12px] pb-[10px] px-[16px] bg-kds-bg-subtle mx-[-16px]">
        <p className="flex-1 min-w-0 text-[14px] leading-[1.4] font-normal text-kds-fg-soft">
          <Trans
            defaults="Supports MP4/MOV (max 100MB, 120s). Videos use your storage quota and are saved to <b>Favorites > Videos > My Uploads</b>."
            components={{ b: <span className="font-semibold" /> }}
          />
        </p>
      </div>
      <div className="flex justify-center px-[16px] pt-[40px] pb-[48px]">
        <ClipUpload
          accept={[...VIDEO_FILE_ACCEPT]}
          maxCount={1}
          beforeUpload={validateReferenceVideoBeforeUpload}
          onFilesChange={(files) => {
            const done = files.find((f) => f.url);
            if (done) onUploadSuccess?.(done);
          }}
          uploadFile={async (file, { onProgress, signal }) => {
            const result = await uploadVideo(file, onProgress, signal);
            return {
              uid: String(result.assetId ?? `upload-${Date.now()}`),
              name: result.fileName ?? file.name,
              url: result.videoUrl,
              type: file.type,
              size: result.fileSize ?? file.size,
              response: result,
            };
          }}
        />
      </div>
    </>
  );
};
